export default "__VITE_ASSET__C5vk$Jnl__"